import React from "react";
import styles from "./SkillsCardComponent.module.scss";
import { combineClasses } from "utils/utils";

const SkillsCardComponent = ({ skills, className = "" }) => {
  return (
    <>
      {skills?.length > 0 && (
        // <section className={styles.user_skills_section}>
        <section className={combineClasses(styles.user_skills_section, className)}>
          <p className={styles.skills_heading}>Skills</p>

          <div className={styles.skills_area}>
            {skills?.map((skill, i) => (
              <p key={i} className={styles.user_single_skill}>
                {skill}
              </p>
            ))}
          </div>
        </section>
      )}
    </>
  );
};

export default SkillsCardComponent;
